/**
 * Anti-repetição da leitura por câmera. Em modo contínuo, o leitor de código de barras dispara
 * o MESMO código dezenas de vezes por segundo enquanto o volume está no enquadramento. Sem
 * controle, um único scan físico viraria dezenas de bipes.
 *
 * Este controle deixa passar uma leitura por código por janela de tempo — 1 scan físico = 1
 * bipe. `agora` é injetado (não usa Date.now() interno) pra o comportamento ser determinístico
 * no teste; o chamador passa `Date.now()`.
 */
export function criarControleLeitura(janelaMs = 1500) {
  const ultimaPorCodigo = new Map<string, number>();

  return {
    /** true = aceitar esta leitura (e marca o instante); false = repetição dentro da janela. */
    deveAceitar(codigo: string, agora: number): boolean {
      const ultima = ultimaPorCodigo.get(codigo);
      if (ultima !== undefined && agora - ultima < janelaMs) {
        return false;
      }
      ultimaPorCodigo.set(codigo, agora);
      return true;
    },
  };
}
